export default {
  modules: {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }], //, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }
      ['clean'],
    ],
  },
  formats: ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent'],
  modulesComment: {
    toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline', 'strike'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']],
  },
  formatsComment: ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet'],
}
